import {createContext, Dispatch} from 'react'
import {AllActions} from './state/actions'
import {DEFAULT_CHR_STATE} from './types/default-chr-state'
import {ChrState} from './types/chr-state'

export const ChrContext = createContext<{
    state: ChrState | undefined
    dispatch: Dispatch<AllActions>
}>({state: DEFAULT_CHR_STATE, dispatch: () => null})
